export default "<p>frontpictures works!</p>\n"